import React, { useState } from "react";
import { navlink } from "../../../data/navlink";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function NavigationBarForDesktop() {
  const [activeDropdown, setActiveDropdown] = useState(null);

  return (
    <div className="flex space-x-8 items-center">
      {navlink.map((data, index) =>
        data.dropdown ? (
          <div
            key={index}
            className="relative"
            onMouseEnter={() => setActiveDropdown(index)}
            onMouseLeave={() => setActiveDropdown(null)}
          >
            <p className="cursor-pointer text-lg font-medium hover:text-goldenYellow transition">
              {data.name}
            </p>

            {/* Dropdown Menu */}
            <div className="bg-transparent w-full h-[20px] absolute " ></div>
            {activeDropdown === index && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{ duration: 0.2 }}
                className={`absolute  mt-1 bg-white text-black shadow-lg rounded-lg p-3 w-56 ${
                  data.name === "Practices" ? "grid left-[-200%] grid-cols-2 gap-1 w-[500px]" : "grid grid-cols-1"
                }`}
              >
              
                {data.dropdownMenu.map((item, i) => (
                  <Link to={
    data.name === "Practices"
      ? `/practice/${item}`
      : item === "Internship"
      ? "/career/internship"
      : "/career/retainership"
  }
                    key={i}
                    className=" p-2 text-sm hover:bg-goldenYellow rounded transition"
                  >
                  
                    {item}
                  </Link>
                ))}
              </motion.div>
            )}
          </div>
        ) : (
          <Link
            key={index}
            to={data.link}
            className="text-lg font-medium hover:text-goldenYellow transition duration-300"
          >
            {data.name}
          </Link>
        )
      )}
    </div>
  );
}
